import axios from "axios";
import API_URLS from "../../../config/global_variables";

const authToken = () => {
  try {
    return JSON.parse(localStorage.userData || "{}").token || "";
  } catch {
    return "";
  }
};

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: authToken(),
});

const ERROR_MESSAGES = {
  VALIDATION_ERROR: "Please fix the highlighted fields.",
  NOT_FOUND: "Tag not found — it may have been deleted in another tab.",
  DUPLICATE_KEY: "A tag with this name already exists.",
  REFERENCED: "Cannot delete — this tag is in use.",
  SERVER_ERROR: "Something went wrong. Please try again.",
};

const mapError = (err) => {
  const apiErr = err?.response?.data?.error;
  const code = apiErr?.code;
  const status = err?.response?.status;
  const fallback =
    apiErr?.message ||
    (status ? `Request failed (${status})` : err?.message || ERROR_MESSAGES.SERVER_ERROR);
  let message = ERROR_MESSAGES[code] || fallback;
  if (code === "VALIDATION_ERROR" && Array.isArray(apiErr?.details) && apiErr.details.length) {
    message = apiErr.details
      .map((d) => `${d.path || "field"}: ${d.message}`)
      .join("\n");
  } else if (code === "REFERENCED" && Array.isArray(apiErr?.details) && apiErr.details.length) {
    message = apiErr.details
      .map((d) => `${d.table || "table"}: ${d.count ?? "?"}`)
      .join(", ");
    message = `${ERROR_MESSAGES.REFERENCED} (${message})`;
  }
  return {
    code: code || (status ? `HTTP_${status}` : "NETWORK_ERROR"),
    status,
    message,
    details: apiErr?.details || [],
  };
};

const buildListParams = (filters = {}) => {
  const params = {};
  if (filters.search) params.search = filters.search;
  if (filters.sort_by) params.sort_by = filters.sort_by;
  if (filters.sort_order) params.sort_order = filters.sort_order;
  params.page = filters.page || 1;
  params.limit = filters.limit || 10;
  return params;
};

const fetchTags = async (filters) => {
  const res = await axios.get(API_URLS.TAGS, {
    headers: headers(),
    params: buildListParams(filters),
  });
  const payload = res?.data?.data || {};
  return {
    items: payload.items || [],
    pagination:
      payload.pagination || { page: 1, limit: filters.limit || 10, total: 0, totalPages: 0 },
  };
};

const fetchTagById = async (id) => {
  const res = await axios.get(API_URLS.TAG_BY_ID(id), { headers: headers() });
  return res?.data?.data || null;
};

const createTag = async (payload) => {
  const res = await axios.post(API_URLS.TAGS, payload, { headers: headers() });
  return res?.data?.data || null;
};

const updateTag = async (id, patch) => {
  const res = await axios.put(API_URLS.TAG_BY_ID(id), patch, { headers: headers() });
  return res?.data?.data || null;
};

const deleteTag = async (id) => {
  const res = await axios.delete(API_URLS.TAG_BY_ID(id), { headers: headers() });
  return res?.data?.data || null;
};

const apiHelpers = {
  fetchTags,
  fetchTagById,
  createTag,
  updateTag,
  deleteTag,
  mapError,
};

export default apiHelpers;
